var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app"
  }, [_c('h1', [_vm._v("Elo Calculator")]), _vm._v(" "), _c('h2', [_vm._v("Calculate your new rating")]), _vm._v(" "), _c('div', {
    staticClass: "myStats"
  }, [_c('label', {
    attrs: {
      "for": "rating"
    }
  }, [_vm._v("Current rating")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.myRating),
      expression: "myRating"
    }],
    attrs: {
      "type": "number",
      "id": "rating",
      "min": "0",
      "max": "4000",
      "placeholder": "Rating"
    },
    domProps: {
      "value": (_vm.myRating)
    },
    on: {
      "change": function($event) {
        _vm.saveValues()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.myRating = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "rating"
    }
  }, [_vm._v("Score")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.score),
      expression: "score"
    }],
    attrs: {
      "type": "number",
      "min": "0",
      "step": "0.5",
      "max": this.opponents.length,
      "placeholder": "Score"
    },
    domProps: {
      "value": (_vm.score)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.score = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "rating"
    }
  }, [_vm._v("K-factor")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.kFactor),
      expression: "kFactor"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.kFactor = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', [_vm._v("10")]), _vm._v(" "), _c('option', [_vm._v("20")]), _vm._v(" "), _c('option', [_vm._v("30")]), _vm._v(" "), _c('option', [_vm._v("40")])])]), _vm._v(" "), _c('form', {
    staticClass: "addOpponent",
    on: {
      "submit": _vm.addOpponent
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newOpponent.rating),
      expression: "newOpponent.rating"
    }],
    staticClass: "addOpponent",
    attrs: {
      "type": "number",
      "min": "800",
      "max": "3000",
      "placeholder": "Add new opponent rating"
    },
    domProps: {
      "value": (_vm.newOpponent.rating)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newOpponent.rating = $event.target.value
      }
    }
  })]), _vm._v(" "), (this.opponents.length > 0) ? _c('div', {
    staticClass: "opponents"
  }, [_c('table', [_vm._m(0), _vm._v(" "), _vm._l((_vm.opponents), function(opponent) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(opponent.rating))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(opponent.expectation.toFixed(2)))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn opponent-remove",
      on: {
        "click": function($event) {
          _vm.removeOpponent(opponent)
        }
      }
    }, [_c('i', [_vm._v("×")])])])])
  })], 2), _vm._v(" "), _c('button', {
    staticClass: "btn",
    staticStyle: {
      "margin-bottom": "10px"
    },
    on: {
      "click": function($event) {
        _vm.clearOpponents()
      }
    }
  }, [_vm._v("\n        Clear opponents\n      ")])]) : _vm._e(), _vm._v(" "), (this.myRating > 800 && this.myRating <= 3000) ? _c('div', {
    staticClass: "results"
  }, [_c('h2', [_vm._v("Expected result")]), _vm._v(" "), _c('p', [_vm._v("\n      " + _vm._s(_vm.totalExpectation.toFixed(2)) + "\n    ")]), _vm._v(" "), _c('h2', [_vm._v("New rating")]), _vm._v(" "), _c('p', [_vm._v("\n      " + _vm._s(_vm.newRating.toFixed(1)) + " \n      "), (_vm.newRating - this.myRating >= 0) ? _c('span', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("(+" + _vm._s((_vm.newRating - this.myRating).toFixed(1)) + ")")]) : _vm._e(), _vm._v(" "), (_vm.newRating - this.myRating < 0) ? _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("(" + _vm._s((_vm.newRating - this.myRating).toFixed(1)) + ")")]) : _vm._e()])]) : _vm._e()])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', [_vm._v("Rating")]), _vm._v(" "), _c('th', [_vm._v("Expected result")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6391d7c8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Opponents.vue
// module id = LKPp
// module chunks = 1